<div
  *ngIf="operation != 'activation'"
  class="login-container login-centered forms-design-system buttons-design-system login-container__password"
>
  <img class="logo" src="/assets/img/vertical-logo.png" alt="Gamelearn" [routerLink]="['/']" />
  <div class="login-box" [ngClass]="{ confirmPasswdLoginBox: done, newPasswdLoginBox: !done }">
    <div class="login-box__title" *ngIf="!done">
      {{ 'auth.changePassword' | translate }}
    </div>
    <div class="login-box__description bold no-padding-top" *ngIf="!done">
      {{ data.userName }}
    </div>
    <div class="login-box__icon paddingTopLarge" *ngIf="done">
      <span class="glicon-check-circle-thin"></span>
    </div>
    <div
      [innerHTML]="'auth.passwordChangeSuccess' | translate : data"
      class="login-box__description no-padding-top"
      *ngIf="done"
    ></div>
    <app-dynamic-form *ngIf="!done" [questions]="questions" [hideSubmit]="true">
      <button
        type="button"
        (click)="onSubmit()"
        form-actions-after
        [disabled]="submitDisabled"
        class="btn btn--primary margin--top margin--bottom"
      >
        {{ 'auth.continue' | translate }}
      </button>
    </app-dynamic-form>
    <ng-container *ngIf="done">
      <button
        [routerLink]="['/login']"
        [queryParams]="{ username: data.userName, sid: data.sid }"
        title=""
        class="btn btn--primary m-btn-login margin--bottom big-size"
      >
        {{ 'enrollment.goInitSesionLabel' | translate }}
      </button>
    </ng-container>
    <div class="login-panel__help no-margin padding--top" *ngIf="!done">
      <a href="https://gamelearn.zendesk.com/hc/es" target="_blank" title="Support">{{
        'auth.helpQuestion' | translate
      }}</a>
    </div>
  </div>
</div>

<div *ngIf="operation === 'activation'" class="login-container">
  <div *ngIf="isContentfulActive" class="login-info" [ngClass]="serviceName">
    <div>
      <app-cms-content [key]="'services.login-' + serviceName"> </app-cms-content>
      <div class="login-info__character" [ngClass]="serviceName"></div>
    </div>
    <div class="login-info__logo showActivation"></div>
  </div>
  <div
    id="activationAccountScroll"
    class="login-panel scroll-y__autoregister forms-design-system buttons-design-system"
    [ngClass]="serviceName"
  >
    <div>
      <div
        *ngIf="serviceName !== 'kepler' && serviceName !== 'mars' && serviceName !== 'roleplay'"
        class="login-panel__logo--mobile activationAccount"
      ></div>
      <ng-container
        *ngIf="
          (serviceName === 'roleplay' || serviceName === 'kepler' || serviceName === 'mars') &&
            logo;
          else gamelearnLogo
        "
      >
        <div class="login-panel__logo--image activationAccount" [ngClass]="serviceName"></div>
        <div class="login-panel__logo--client">
          <img [src]="logo" alt="" />
        </div>
      </ng-container>
      <ng-template #gamelearnLogo>
        <div class="login-panel__logo--image"></div>
      </ng-template>

      <div class="login-panel__title">
        {{ 'auth.activateYourAccount' | translate }}
      </div>

      <app-dynamic-form [questions]="questions" [hideSubmit]="true" [formError]="error">
        <div class="login-panel__block" form-actions-after>
          <div class="legacy-text" [innerHTML]="'enrollment.legacyLabel' | translate"></div>
          <div *ngIf="clientTermsUrl" class="checkbox small-check checkbox-with-link">
            <input
              type="checkbox"
              id="clientDisclaimerPrivacy"
              name="clientDisclaimerPrivacy"
              [(ngModel)]="data.clientDisclaimerPrivacy"
              required
            />
            <label for="clientDisclaimerPrivacy"></label>
            <span
              class="no-label-text"
              [innerHTML]="'enrollment.clientTermsEnrollment' | translate : { url: clientTermsUrl }"
            ></span>
          </div>
          <div class="checkbox small-check checkbox-with-link">
            <input
              type="checkbox"
              id="disclaimerPrivacy"
              name="disclaimerPrivacy"
              [(ngModel)]="data.disclaimerPrivacyAndTerms"
              required
            />
            <label for="disclaimerPrivacy"></label>
            <span class="no-label-text" [innerHTML]="'enrollment.legacyText' | translate"></span>
          </div>
          <div *ngIf="serviceName !== 'kepler'" class="checkbox small-check checkbox-with-link">
            <input
              type="checkbox"
              id="disclaimerMarketing"
              name="disclaimerMarketing"
              [(ngModel)]="data.disclaimerMarketing"
            />
            <label
              for="disclaimerMarketing"
              [innerHTML]="'enrollment.acceptMarketingCommunications' | translate"
            >
            </label>
          </div>
        </div>
        <button
          type="button"
          (click)="onSubmit()"
          form-actions-after
          [disabled]="submitDisabled || error"
          class="btn btn--primary"
        >
          {{ 'actions.activationAccount' | translate }}
        </button>
      </app-dynamic-form>

      <div class="login-panel__help no-margin padding__top--double">
        <span>{{ 'auth.helpQuestion' | translate }}</span>
        <a href="{{ supportUrl }}" target="_blank" title="Support">{{
          'auth.contactLabel' | translate
        }}</a>
        <!-- <a (click)='changeUser()' class="login-panel__link">{{ 'auth.changeUser' | translate }}</a> -->
      </div>
      <div
        *ngIf="serviceName === 'kepler' || serviceName === 'mars' || serviceName === 'roleplay'"
        class="login-panel__logo--mobile activationAccount"
      ></div>
    </div>
  </div>
</div>
